import * as pbi from 'powerbi-client';

// orange and white and purple and blue. Green and blue and green... I can sing a rainbow, sing a rainbow, sing a rainbow too.
const randomId = document.getElementById("powerBiScript").getAttribute("data-randomId")
const type = document.getElementById("powerBiScript").getAttribute("data-type")
const id = document.getElementById("powerBiScript").getAttribute("data-id")
const embedUrl = document.getElementById("powerBiScript").getAttribute("data-embedUrl")
const embedToken = document.getElementById("powerBiScript").getAttribute("data-embedToken")
const pageName = document.getElementById("powerBiScript").getAttribute("data-pageName")
const filters = document.getElementById("powerBiScript").getAttribute("data-filters")
const filterPane = document.getElementById("powerBiScript").getAttribute("data-filterPane")
const navContentPane = document.getElementById("powerBiScript").getAttribute("data-navContentPane")
const dashboardId = document.getElementById("powerBiScript").getAttribute("data-dashboardId")
const expirationTokenRaw = document.getElementById("powerBiScript").getAttribute("data-expirationToken")
const updateTokenUrl = document.getElementById("powerBiScript").getAttribute("data-updateTokenUrl")
const workspaceId = document.getElementById("powerBiScript").getAttribute("data-workspaceId")
const kobling = document.getElementById("powerBiScript").getAttribute("data-kobling")

$('#embedContainer' + randomId).height($('#embedContainer' + randomId).width() / 2)

switch (type) {
  case 'report':
    loadReportPowerBI()
    break
  case 'dashboard':
    loadDashboardPowerBI()
    break
  case 'tiles':
    loadTilesPowerBI()
    break
}

function loadReportPowerBI () {
  if (id && embedUrl && embedToken) {
    const models = pbi.models;
    const processedFilters = filters ? filters.replace(/&quot;/g, '"') : "";
    const embedConfiguration = {
      type,
      id,
      embedUrl,
      tokenType: models.TokenType.Embed,
      accessToken: embedToken,
      filters: processedFilters ? JSON.parse(processedFilters) : null,
      pageName,
      settings: {
        filterPaneEnabled: (filterPane == 'true'),
        navContentPaneEnabled: (navContentPane == 'true'),
      }
    };
    const embedContainer = document.getElementById('embedContainer' + randomId);
    powerbi.embed(embedContainer, embedConfiguration);
  }
}

function loadDashboardPowerBI () {
  if (dashboardId && embedUrl && embedToken) {
    const models = pbi.models;

    const embedConfiguration = {
      type,
      tokenType: models.TokenType.Embed,
      accessToken: embedToken,
      embedUrl,
      id: dashboardId,
      pageView: 'fitToWidth'
    };
    const embedContainer = document.getElementById('embedContainer' + randomId);
    powerbi.embed(embedContainer, embedConfiguration);
  }
}

function loadTilesPowerBI () {
  if (embedUrl && embedToken && dashboardId && id) {
    const models = pbi.models;

    const embedConfiguration = {
      type: 'tile',
      tokenType: models.TokenType.Embed,
      accessToken: embedToken,
      embedUrl,
      id,
      dashboardId
    };
    const embedContainer = document.getElementById('embedContainer' + randomId);
    powerbi.embed(embedContainer, embedConfiguration);
  }
}

$(window).resize(function () {
  const list = $('[id^="embedContainer"]');
  for (let i = 0; i < list.length; i++) {
    $('#' + list[i].id).height($('#' + list[i].id).width() / 2)
  }
});

let expirationToken = expirationTokenRaw;
setInterval(() => checkTokenAndUpdate(expirationToken), 10000);

function checkTokenAndUpdate (expirationStr) {
  // Get the current time
  const currentTime = Date.now();
  const expiration = Date.parse(expirationStr);

  // Time until token expiration in milliseconds
  const timeUntilExpiration = expiration - currentTime;
  const timeToUpdate = 10 * 60 * 1000;

  // Update the token if it is about to expired

  if (timeUntilExpiration <= timeToUpdate) {
    console.log("Updating report access token");

    if (updateTokenUrl) {
      $.post(updateTokenUrl, {
        Id: id,
        workspaceId,
        dashboardId,
        type,
        kobling,
        filters,
        pageName
      }, function (data) {
        expirationToken = data.expirationToken
        console.log("Expiration: " + expirationToken);
        switch (data.type) {
          case 'report':
            reloadReportPowerBI(data.Id, data.embedUrl, data.embedToken, data.filters, data.workspaceId, data.dashboardId, data.kobling, data.pageName)
            break
          case 'dashboard':
            reloadDashboardPowerBI(data.dashboardId, data.embedUrl, data.embedToken)
            break
          case 'tiles':
            reloadTilesPowerBI(data.embedUrl, data.embedToken, data.dashboardId, data.Id)
            break
        }
      });
    }
  }
}

function reloadReportPowerBI (id, embedUrl, embedToken, filters, workspaceId, dashboardId, kobling, pageName) {
  if (id && embedUrl && embedToken) {
    const models = pbi.models;
    const embedConfiguration = {
      type: 'report',
      id,
      embedUrl,
      tokenType: models.TokenType.Embed,
      accessToken: embedToken,
      filters: filters ? JSON.parse(filters.replace(/&quot;/g, '"')) : null,
      workspaceId,
      dashboardId,
      kobling,
      pageName,
      settings: {
        filterPaneEnabled: (filterPane == 'true'),
        navContentPaneEnabled: (navContentPane == 'true'),
      }
    };
    const embedContainer = document.getElementById('embedContainer' + randomId);
    powerbi.embed(embedContainer, embedConfiguration);
  }
}

function reloadDashboardPowerBI (dashboardId, embedUrl, embedToken) {
  if (dashboardId && embedUrl && embedToken) {
    const models = pbi.models;

    const embedConfiguration = {
      type: 'dashboard',
      tokenType: models.TokenType.Embed,
      accessToken: embedToken,
      embedUrl,
      id: dashboardId,
      pageView: 'fitToWidth'
    };
    const embedContainer = document.getElementById('embedContainer' + randomId);
    powerbi.embed(embedContainer, embedConfiguration);
  }
}

function reloadTilesPowerBI (embedUrl, embedToken, dashboardId, id) {
  if (embedUrl && embedToken && dashboardId && id) {
    const models = pbi.models;

    const embedConfiguration = {
      type: 'tile',
      tokenType: models.TokenType.Embed,
      accessToken: embedToken,
      embedUrl,
      id,
      dashboardId: dashboardId
    };
    const embedContainer = document.getElementById('embedContainer' + randomId);
    powerbi.embed(embedContainer, embedConfiguration);
  }
}
